<template>
  <b-button size='sm' :disabled='disabled' class='modal-button ml-auto' :variant='variant' @click="$emit('click')">
    <slot></slot>
  </b-button>
</template>
<script>
export default {
  name: 'BasicButton',
  props: {
    variant: {
      type: String,
      default: 'primary'
    },
    disabled: Boolean
  }
}
</script>
<style lang='scss' scoped>
.modal-button {
  margin-right: 1.7%;
}
</style>
